import type { CoreStoreType } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { GameStatus } from '../../../store/slices/game/types';
import { toastActions } from '../../../store/slices/toast/slice';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

// Message example
// {"canceled":{"id":"186742501","cancelReason":"Flapper issue","cancelCode":"1041","seq":13}}

export class GameCommunicationCancelledProcessor implements IGameCommunicationProcessor {
  messageName = 'canceled';

  process(message: GameCommunicationMessageType, store: CoreStoreType): void {
    store.dispatch(toastActions.createToast('TOAST_GAME_CANCELLED'));
    store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.GameCancelled));
  }
}
